import { formatAddress } from "@remi/formatting";

import { ProjectStatusIcons } from "~/components/project/ProjectStatusIcons";
import { useBid } from "~/hooks/useBid";
import { useWorksite } from "~/hooks/useWorksite";

export const HomeownerBidInfo = ({ bidId }: { bidId: number }) => {
  const { data: bid } = useBid(bidId);
  const { data: worksite } = useWorksite(bid?.workSite.id);

  if (!bid || !worksite) {
    return null;
  }

  return (
    <div className="type-xs flex h-8 w-full items-center gap-2 overflow-hidden rounded-md border border-border-primary bg-background-secondary px-2">
      {ProjectStatusIcons[bid.bidProject.status]}
      <span className="min-w-fit text-nowrap font-medium text-text-secondary">Bid {bidId}</span>
      <span className="truncate text-text-primary">{formatAddress(worksite.propertyAddress)}</span>
    </div>
  );
};
